import React from 'react';
import  Class11Isro  from 'views/Class11Isro';
const VissionAndMissionPage = () => {
  return <Class11Isro/>;
};

export default VissionAndMissionPage;